import { CLEAR_REDIRECT_PATH } from 'actions';

export default function clearRedirectPath() {
  return (dispatch) => dispatch({ type: CLEAR_REDIRECT_PATH });
}
